<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <card>
                        <template slot="header">
                            <h4 class="card-title">Шаблоны</h4>
                            <p class="card-category"></p>
                            <div class="row stats-block mt10">
                                <span>Количество шаблонов: <span class="number">{{ stats.templatesCount }}</span> (<span class="number">{{ stats.premiumTemplatesCount }}</span> - premium, <span class="number">{{ stats.freeTemplatesCount }}</span> - free) </span>
                            </div>

                            <div class="row mt10">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="categoryId" id="category-filter"
                                                @change="saveFilters('tt_category', categoryId)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option v-for="c in categories" v-bind:value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="status" id="status-filter"
                                                @change="saveFilters('tt_status', status)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">Опубликовано</option>
                                            <option value="0">Ожидает</option>
                                            <option value="2">Запланировано</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">Copyrighted</label>
                                        <select v-model="isCopyrighted" id="trendy-filter"
                                                @change="saveFilters('tt_is_copyrighted', isCopyrighted)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="0">Free</option>
                                            <option value="1">Copyrighted</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label class="control-label">New</label>
                                        <select v-model="isNew" id="trendy-filter"
                                                @change="saveFilters('tt_is_new', isNew)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="" selected>Все</option>
                                            <option value="1">New</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Теги</label>
                                        <vue-multiselect v-model="tag_ids"
                                                         :searchable="false"
                                                         label="name"
                                                         track-by="id"
                                                         :options="tags"
                                                         :multiple="true"
                                                         :taggable="true"
                                                         @input="addTag">
                                        </vue-multiselect>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Поиск по ID"
                                              v-model="filteredId"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-2">
                                    <fg-input type="text"
                                              label="Поиск по песне"
                                              v-model="songId"
                                              placeholder="">
                                    </fg-input>
                                </div>
                                <div class="col-md-1">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Фильтровать
                                    </button>
                                </div>
                                <div class="col-md-3" v-if="role === 302">
                                    <button type="submit" class="btn btn-success btn-fill float-right"
                                            @click.prevent="add">
                                        Добавить шаблон
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="control-label">Сортировка</label>
                                        <select v-model="sortBy" id="sort-by"
                                                @change="saveSort('tt_sort_by', sortBy)"
                                                aria-describedby="addon-right addon-left" class="form-control">
                                            <option value="id" selected>По умолчанию</option>
                                            <option value="use_count">По популярности</option>>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-1">
                                    <button type="submit" class="btn btn-info btn-fill"
                                            @click.prevent="filter">
                                        Сортировать
                                    </button>
                                </div>
                            </div>
                            <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                                 @click.prevent="next">
                                След.
                            </div>
                            <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                                 @click.prevent="prev">
                                Пред.
                            </div>
                        </template>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <slot name="columns">
                                    <th v-for="column in columns">
                                        <span v-if="column === 'preview_src_full'">превью</span>
                                        <span v-else-if="column === 'counter'">экспорт</span>
                                        <span v-else-if="column === 'category'">категория</span>
                                        <span v-else-if="column === 'is_trending_music'">тренд</span>
                                        <span v-else-if="column === 'status'">статус</span>
                                        <span v-else-if="column === 'sort'">сортировка</span>
                                        <span v-else-if="column === 'videos'">количество видео</span>
                                        <span v-else-if="column === 'duration'">длительность, сек.</span>
                                        <span v-else-if="column === 'use_count'">использования</span>
                                        <span v-else-if="column === 'release_date'">дата публикации</span>
                                        <span v-else>{{column}}</span>
                                    </th>
                                </slot>
                                </thead>
                                <tbody>
                                <tr v-for="item in data">
                                    <slot :row="item">
                                        <td v-for="column in columns">
                                            <div v-if="column === 'preview_src_full'" @click="edit(item['id'])">
                                                <div class="device-block device1" v-if="!isVideo(item[column])"
                                                     :style="{ backgroundImage: 'url(' + item[column] + ')' }">
                                                    <span class="free-badge" v-if="isFree(item['is_premium'])">free</span>
                                                </div>
                                                <div class="device-block device1" v-if="isVideo(item[column])"
                                                     @click.prevent="openVideo(item['src_full'])">
                                                    <video muted loop autoplay playsinline id="video_player"
                                                           :key="item[column]"
                                                           style="max-width: 100%; cursor: pointer;">
                                                        <source :src="item[column]"/>
                                                    </video>
                                                    <span class="free-badge" v-if="isFree(item['is_premium'])">free</span>
                                                </div>
                                            </div>
                                            <span v-else-if="column === 'color'  && item[column]"
                                                    class="color-block"
                                                  :style="{ backgroundColor: '#' + item[column] }"></span>
                                            <span v-else-if="column === 'color_group' && item[column]"
                                                  class="color-block"
                                                  :style="{ backgroundColor: '#' + item[column] }"></span>
                                            <span v-else-if="column === ''">
                                                <a v-if="role === 302" class="text-primary" @click="edit(item['id'])">Изменить</a>
                                                <img class="new-tab" src="/static/img/new-tab.png" @click="openNewTab(item['id'])"/>
                                            </span>
                                            <span v-else-if="column === 'status'">
                                                <span class="font-weight-bold text-primary" v-if="item['release_date']">Запланировано</span>
                                                <span class="font-weight-bold text-success" v-else-if="item[column] === 1">Опубликовано</span>
                                                <span class="font-weight-bold text-warning" v-else-if="item[column] === 0">Ожидает</span>
                                            </span>
                                            <span v-else-if="column === 'is_trending_music'">
                                                <span class="text-purple" v-if="item[column] === 1">Тренд</span>
                                            </span>
                                            <span class="" v-else-if="column === 'release_date'">
                                                {{ item[column] | toEasyDate }}
                                            </span>
                                            <span class="" v-else-if="column === 'duration'">
                                                <span>{{ item[column] }}</span>
                                            </span>
                                            <span v-else-if="column === 'type'">
                                                <img class="premium" src="/static/img/live.png" v-if="item[column] === 2"/>
                                            </span>
                                            <span v-else>{{item[column]}}</span>
                                        </td>
                                    </slot>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div :class="{ 'disabled' : data.length < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="next">
                            След.
                        </div>
                        <div :class="{ 'disabled' : offset < limit }" class="pagination-button btn btn-warning btn-fill float-right"
                             @click.prevent="prev">
                            Пред.
                        </div>

                    </card>

                </div>

                <div class="clearfix"></div>
                <div class="video-bg" v-if="activeVideo" @click.prevent="closeVideo()"></div>
                <div id="player" v-if="activeVideo">
                    <video onloadstart="this.volume=0.1" controls autoplay id="video_player"
                           style="max-width: 100%;">
                        <source v-bind:src="activeVideo"/>
                    </video>
                    <button type="button" class="btn btn-fill btn-close"
                            @click.prevent="closeVideo()"
                            v-bind:class="{ 'active-state': activeVideo }">
                        Закрыть
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import {sortBy} from "lodash/collection";

    const _ = require('lodash')
    const axios = require('axios')
    const moment = require('moment')
    import LTable from 'src/components/UIComponents/Table.vue'
    import Card from 'src/components/UIComponents/Cards/Card.vue'

    export default {
        components: {
            LTable,
            Card,
        },
        created: function () {
            let self = this;

            let token = localStorage.getItem('token');

            axios.get(
                `${this.$hostname}/admin/categories/`,
                {
                    'params': {

                    },
                    'headers': {
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then(function (response) {
                    self.loading = false;
                    self.categories = response.data;
                    localStorage.setItem('categories', JSON.stringify(response.data));

                    self.get();
                })
                .catch(function (error) {
                    self.loading = false;
                    console.log(error)
                });
        },
        data() {
            return {
                columns: ['id', 'category', 'is_trending_music', 'preview_src_full', 'videos', 'duration', 'sort', 'use_count', 'status', ''],
                data: [],
                tags: [],
                role: parseInt(localStorage.getItem('role')) || 0,
                categoryId: localStorage.getItem('tt_category') ? localStorage.getItem('tt_category') : "",
                status: localStorage.getItem('tt_status') ? localStorage.getItem('tt_status') : "",
                isTrendy: localStorage.getItem('tt_is_trendy') ? localStorage.getItem('tt_is_trendy') : "",
                isCopyrighted: localStorage.getItem('tt_is_copyrighted') ? localStorage.getItem('tt_is_copyrighted') : "",
                isNew: localStorage.getItem('tt_is_new') ? localStorage.getItem('tt_is_new') : "",
                categories: [],
                filteredId: null,
                activeVideo: "",
                songId: null,
                limit: 10,
                sortBy: localStorage.getItem('tt_sort_by') ? localStorage.getItem('tt_sort_by') : "id",
                offset: parseInt(localStorage.getItem('tt_active_offset')) || 0,
                stats: {
                    templatesCount: 0,
                    freeTemplatesCount: 0,
                    premiumTemplatesCount: 0,
                },
                tag_ids: localStorage.getItem('tt_tag_ids') ? JSON.parse(localStorage.getItem('tt_tag_ids')) : null,
            }
        },
        filters: {
            toEasyDate (value) {
                if (value) {
                    return moment(String(value)).format('DD.MM.YYYY HH:mm')
                } else {
                    return '';
                }
            },
            toShortText (value) {
                if (value) {
                    return value.length > 10 ? value.substr(0, 10) + '...' : value.substr(0, 10)
                } else {
                    return '';
                }
            }
        },
        methods: {
            isVideo: function(url) {
                return url.indexOf('.mp4') > -1;
            },
            isFree: function (isPremium) {
                return parseInt(isPremium, 10) !== 1;
            },
            resetStatsCount: function() {
                this.stats = {
                    templatesCount: 0,
                    freeTemplatesCount: 0,
                    premiumTemplatesCount: 0,
                    averageTemplateCount: 0,
                    averageFreeCount: 0,
                    averagePremiumCount: 0,
                }
            },
            add: function () {
                this.$router.push('/templates/create');
            },
            filter: function () {
                localStorage.setItem('tt_active_offset', "0");
                this.offset = 0;
                this.get();
            },
            edit: function (id) {
                if (this.role === 2) {
                    return false;
                }
                //localStorage.setItem('w_last_opened_id', parseInt(id));
                this.$router.push({
                    name: 'edit-template',
                    params: {id: id}
                });
            },
            openNewTab: function (id) {
                if (this.role === 2) {
                    return false;
                }
                const routeData = this.$router.resolve({
                    name: 'edit-template',
                    params: { id: id }
                });

                window.open(routeData.href, '_blank');
            },
            get: function () {
                let self = this;

                let token = localStorage.getItem('token');

                let categoryId = this.categoryId === null ? '' : this.categoryId;
                let status = this.status === null ? '' : this.status;
                let isTrendy = this.isTrendy === null ? '' : this.isTrendy;
                let isCopyrighted = this.isCopyrighted === null ? '' : this.isCopyrighted;
                let isNew = this.isNew === null ? '' : this.isNew;
                let filteredId = this.filteredId === null ? '' : this.filteredId;
                let songId = this.songId === null ? '' : this.songId;
                let fullTagIds = this.tag_ids === null ? '' : this.tag_ids;

                let tagIds = []
                _.map(fullTagIds, (t) => {
                    tagIds.push(t.id);
                })

                self.resetStatsCount();

                axios.get(
                    `${this.$hostname}/admin/templates`,
                    {
                        'params': {
                            categoryId: categoryId,
                            status: status,
                            isTrendy: isTrendy,
                            isCopyrighted: isCopyrighted,
                            isNew: isNew,
                            limit: self.limit,
                            offset: self.offset,
                            filteredId: filteredId,
                            songName: songId,
                            tagIds: tagIds,
                            sortBy: self.sortBy
                        },
                        'headers': {
                            'Authorization': 'Bearer ' + token
                        }
                    })
                    .then(function (response) {
                        let data = response.data;

                        self.data = data.templates;

                        self.tags = data.tags;

                        self.stats.templatesCount = data.templates_count;
                        self.stats.premiumTemplatesCount = data.premium_count;
                        self.stats.freeTemplatesCount = data.templates_count - data.premium_count;


                    })
                    .catch(function (error) {
                        console.log(error)
                    })

            },
            prev: function () {
                if (this.offset >= this.limit) {
                    this.offset -= this.limit;
                    this.get();
                    localStorage.setItem('tt_active_offset', parseInt(this.offset));
                }
            },
            next: function () {
                if (this.data.length === this.limit) {
                    this.offset += this.limit;
                    this.get();
                    localStorage.setItem('tt_active_offset', parseInt(this.offset));
                }
            },
            saveFilters: function(name, value) {
                localStorage.setItem(name, value);
            },
            saveSort: function(name, value) {
                localStorage.setItem(name, value);
            },
            openVideo: function (src) {
                if (this.role === 2) {
                    this.activeVideo = src;
                }
            },
            closeVideo: function () {
                this.activeVideo = "";
            },
            addTag (tags) {
                this.tag_ids = tags;
                localStorage.setItem('tt_tag_ids', JSON.stringify(this.tag_ids));
            },
        },
        beforeRouteLeave (to, from , next) {
            if (to.path.indexOf('templates') < 1) {
                localStorage.setItem('tt_active_offset', "0");
                localStorage.setItem('tt_category', "");
                localStorage.setItem('tt_status', "");
                localStorage.setItem('tt_is_trendy', "");
                localStorage.setItem('tt_is_new', "");
                localStorage.setItem('tt_is_copyrighted', "");
                localStorage.setItem('tt_tag_ids', null);
                localStorage.setItem('tt_sort_by', "id");
            }
            next();
        },
    }
</script>
<style scoped>
    .pagination-button {
        height: 30px;
        padding: 1px 16px;
        margin-left: 20px;
        color: #fff !important;
    }
    .pagination-button.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
    .text-primary {
        cursor: pointer;
    }
    .stats-block {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .stats-block > span {
        display: block;
        width: 100%;
        margin-left: 15px;
        margin-bottom: 3px;
    }
    .stats-block span span.number {
        font-weight: 700;
        font-size: 18px;
    }
    .wallpapers-preview {
        cursor: pointer;
        max-height: 200px;
    }

    .mt10 {
        margin-top: 10px;
    }

    .btn-fill {
        margin-top: 25px;
    }
    .premium {
        width: 30px;
        margin-left: 20px;
    }

    .device-block {
        position: relative;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
    }

    .device-block span {
        position: absolute;
        top: -30px;
        left: 5px;
    }
    .bg-danger {
        font-size: 18px;
        padding: 3px;
        border-radius: 4px;
        background-color: rgba(255, 70, 50, 0.5) !important;
    }
    .device1 {
        width: 140px;
        height: 248px;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .mt30 {
        margin-top: 30px;
    }
    .emodji {
        font-size: 24px;
    }
    .color-block {
        display: block;
        width: 50px;
        height: 50px;
    }
    th {
        padding: 12px 8px;
    }
    .premium {
        width: 30px;
        margin-left: 20px;
    }

    .video-bg {
        position: fixed;
        top: 0px;
        right: 0px;
        width: 100%;
        height: 100%;
        background-color: #000000;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 10;
        opacity: 0.7;
    }

    #player {
        width: 324px;
        height: 700px;
        position: fixed;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -30%);
        background: #fff;
        z-index: 11;
        transition: all .3s ease-out;
    }


    .btn-close {
        display: none;
        width: 283px;
        height: 40px;
        margin: 33px auto;
        background: #000;
        border: none;
        -webkit-animation: .07s ease 0s normal forwards 1 fadein;
        animation: .07s ease 0s normal forwards 1 fadein;
        font-size: 15px;
    }

    .btn-close.active-state {
        display: block;
    }
    .btn-close:hover {
        background: #000;
        opacity: 0.8 !important;
    }


    .premium-icon {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 6px;
        right: 6px;
    }

    .device-block .free-badge {
        position: absolute;
        top: 5px;
        right: 5px;
        left: auto;
        font-size: 13px;
        font-weight: 700 !important;
        line-height: 1;
        color: #fff;
        padding: 5px 8px;
        border-radius: 6px;
        background-color: #54abfe;
    }

    .text-purple {
        font-weight: 700 !important;
        color: #9368E9;
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Templates.vue